import { gql } from '@apollo/client'

export const ColumnFormattingFragment = gql`
  fragment ColumnFormatting on TableColumn {
    formatPreset
    formatOptions
  }
`

export const EnumSetFragment = gql`
  fragment EnumSetFields on TableColumn {
    enumSet {
      id
      options {
        id
        label
        colorPreset
        colorCustom
        iconName
        icon {
          id
        }
        order
      }
    }
  }
`

export const LookupProviderColumnFragment = gql`
  fragment LookupProviderColumn on TableColumn {
    id
    type
    ...ColumnFormatting
  }
  ${ColumnFormattingFragment}
`

export const ResolvedSourceColumnFragment = gql`
  fragment ResolvedSourceColumn on TableColumn {
    resolvedSourceColumn {
      column {
        id
        type
        innerType
        ...ColumnFormatting
        ...EnumSetFields
      }
    }
  }
  ${ColumnFormattingFragment}
  ${EnumSetFragment}
`
